import { produce } from 'immer';
import { GO_BACK, GO_FORWARD, GO_TO_PAGE } from '../actions/gameGuideActions';
const initialState = {
    pageHistory: ['home'],
    pageIndex: 0
};
const gameGuideReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case GO_TO_PAGE: {
                const page = action.payload;
                if (draft.pageHistory[draft.pageIndex] === page) {
                    // already at the desired page
                    return;
                }
                if (draft.pageIndex < draft.pageHistory.length - 1) {
                    // delete 'forward' history
                    draft.pageHistory = draft.pageHistory.slice(0, draft.pageIndex + 1);
                }
                draft.pageIndex++;
                draft.pageHistory.push(page);
                break;
            }
            case GO_BACK: {
                draft.pageIndex = Math.max(0, draft.pageIndex - 1);
                break;
            }
            case GO_FORWARD: {
                draft.pageIndex = Math.min(draft.pageHistory.length - 1, draft.pageIndex + 1);
                break;
            }
        }
    });
};
export default gameGuideReducer;
